function smoothScroll() {
  init();
}
function init() {
  var link = jQuery('a[href*="#"]');
  var speed = 1000;
  jQuery(link).bind('click', function (e) {
    var url = jQuery(this).attr('href');
    if (url.startsWith('#')) {
      smooth(e, url);
    }
  });
  function getSections() {
    var arr = [];
    link.each(function (i, item) {
      var elem = jQuery(item).attr('href');
      if (elem.trim().startsWith('#')) {
        if (jQuery(elem).length > 0) {
          arr.push(jQuery(elem));
        }
      }
    });
    return arr;
  }
  function smooth(e, id) {
    e.preventDefault();
    if (id === '#') {
      return;
    }
    if (jQuery(id).length !== 0) {
      var _jQuery$offset = jQuery(id).offset(),
        top = _jQuery$offset.top;
      top -= jQuery('.header').outerHeight();
      jQuery('body,html').animate({
        scrollTop: top
      }, speed);
    }
  }
}
export default smoothScroll;